import * as Sentry from "@sentry/nextjs";
import type { FunctionComponent } from "react";
import type { FallbackProps } from "react-error-boundary";

import { getLocalstorageExtraInformation } from "shared/lib/sentry";

export const ErrorHandler: FunctionComponent<FallbackProps> = ({ error }) => {
  Sentry.captureException(error, {
    extra: getLocalstorageExtraInformation(),
  });
  return null;
};
ErrorHandler.displayName = "ErrorHandler";
